import * as React from "react";
import { Text, View, Image, Button } from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import Ionicons from "@expo/vector-icons/Ionicons";
import API_KEY from "../API_KEY";
import Chart from "./Chart";
import { Card, Header } from "react-native-elements";
import StockCard from "./StockCard";
import StockTickers from "../stockTickers.json";
import { ScrollView } from "react-native-gesture-handler";
import SwiperComponent from "./Swiper";
import Industry from './Industry'
import { SafeAreaView } from "react-native-safe-area-context";
const alpha = require("alphavantage")({ key: API_KEY });

export default class HomeScreen extends React.Component {

  render() {
    return (
      <SafeAreaView style={{ flex: 1, }}>


        <Industry navigation={this.props.navigation}/>
      </SafeAreaView>

    );
  }
}
